/* One cart mutation per acceptance; reconcile uncertain responses without retrying. */
(function(root){
'use strict';
async function run({cart,selected,config,dismissed=[],request,reconcile,sections=['cart-drawer','cart-icon-bubble']}){
 const rules=root.NCBundleRules;
 try{
  const fresh=await request('cart.js');
  const handles=[...new Set([selected.rule.to,...(rules.COMPONENTS[selected.rule.to]||[]),...(selected.rule.to==='full'?['pour']:[]),...(selected.rule.to==='setting'?['duo']:[])])];
  await Promise.all(handles.map(async key=>{
   const handle=rules.H[key],old=config.products[handle];
   const product=await request('products/'+handle+'.js');
   const variant=product.variants.find(v=>Number(v.id)===Number(old.id));
   config.products[handle]={...old,available:!!variant?.available,price:variant?.price??old.price};
  }));
  const confirmed=rules.evaluate(fresh,config,dismissed);
  if(rules.fingerprint(cart)!==rules.fingerprint(fresh)||!confirmed||confirmed.rule.id!==selected.rule.id||confirmed.delta!==selected.delta||confirmed.saving!==selected.saving)
   throw new Error('Your bag or this offer changed. Please review the latest details before upgrading.');
  const result=confirmed.rule.additive
   ?await request('cart/add.js',{items:[{id:confirmed.product.id,quantity:1}],sections,sections_url:root.location?.pathname||'/'})
   :await request('cart/update.js',{updates:confirmed.updates,sections,sections_url:root.location?.pathname||'/'});
  const actual=await request('cart.js');
  const target=actual.items.find(i=>Number(i.id)===Number(confirmed.product.id));
  const oldRemain=confirmed.sourceKeys.some(key=>actual.items.some(i=>i.key===key));
  const unrelated=fresh.items.filter(i=>!confirmed.sourceKeys.includes(i.key));
  const changedUnrelated=unrelated.some(i=>!actual.items.some(a=>a.key===i.key&&(a.quantity===i.quantity||(confirmed.rule.additive&&Number(a.id)===Number(confirmed.product.id)&&a.quantity===i.quantity+1))));
  const countTarget=c=>c.items.filter(i=>Number(i.id)===Number(confirmed.product.id)).reduce((n,i)=>n+i.quantity,0);
  const targetCorrect=confirmed.rule.additive?countTarget(actual)===countTarget(fresh)+1:target?.quantity===confirmed.quantity;
  if(!target||!targetCorrect||oldRemain||changedUnrelated)
   throw new Error('Please review your bag: Shopify could not complete the whole upgrade.');
  return {cart:actual,sections:result.sections,offer:confirmed};
 }catch(error){
  // The server may have accepted a request even when the browser lost its response.
  try{await reconcile();}catch{throw new Error('We could not confirm your latest bag. Refresh the page before continuing.');}
  throw error;
 }
}
root.NCCartTransaction={run};
if(typeof module!=='undefined'&&module.exports)module.exports={run};
})(typeof window==='undefined'?globalThis:window);
